export * from "@/node-lib/pupil-api/types/lessonAttempt";
export * from "@/node-lib/pupil-api/types/teacherNote";
